// Function to Get All Users Data to Admin Screen table
import axios from 'axios';
import config from './../../../config';
const getUserReports = async (userId) => {
  const token = localStorage.getItem('googleIdToken');
  try {
    const result = await axios.get(
      `${config.apiURL}/getUserReports/v2/${userId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return Object.keys(result?.data).length !== 0 ? result?.data : {};
  } catch (err) {
    return {};
  }
};

// Identical requests made at the same moment (Login's background load and the
// Home page's own load right after it) share one network call. Nothing is
// kept once it finishes, so this is not a cache.
const reportsInFlight = new Map();

const getUserReportsGroupByOrgName = (userId) => {
  const key = String(userId);
  if (reportsInFlight.has(key)) return reportsInFlight.get(key);
  const token = localStorage.getItem('googleIdToken');
  const request = axios
    .get(`${config.apiURL}/getUserReportsById/v2/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((result) => (Array.isArray(result?.data) ? result?.data : []))
    .catch(() => [])
    .finally(() => reportsInFlight.delete(key));
  reportsInFlight.set(key, request);
  return request;
};

const getAllPBIRoles = async () => {
  const token = localStorage.getItem('googleIdToken');
  try {
    const result = await axios.get(
      `${config.apiURL}/v2/getAllUserRolesMappingPBI`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return Array.isArray(result?.data) ? result?.data : [];
  } catch (err) {
    return [];
  }
};

const getAllPBINamesApi = async () => {
  const token = localStorage.getItem('googleIdToken');
  try {
    const result = await axios.get(`${config.apiURL}/v2/getAllUserNamesPBI`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return Array.isArray(result?.data) ? result?.data : [];
  } catch (err) {
    return [];
  }
};

// The user's most-opened reports (server-side usage data), most used first.
// userId is optional: omit it for the signed-in user; an admin viewing as
// someone else passes that user's ID.
const getTopReports = async (userId, limit = 6) => {
  const token = localStorage.getItem('googleIdToken');
  try {
    const result = await axios.get(`${config.apiURL}/getTopReports`, {
      params: { ...(userId ? { userId } : {}), limit },
      headers: { Authorization: `Bearer ${token}` },
    });
    return Array.isArray(result?.data) ? result.data : [];
  } catch (err) {
    return [];
  }
};

export default getUserReports;
export {
  getAllPBINamesApi,
  getAllPBIRoles,
  getTopReports,
  getUserReportsGroupByOrgName,
};
